import { ApiError, type MessageKey } from "@tovi/shared";

/**
 * What the shift modal shows for a refused open or close.
 *
 * Every other screen calls `resolveErrorMessage`, which falls back to the
 * server's English `message` when a throw carries no reason — the right
 * choice for somebody debugging a client. This modal's reader is a cashier
 * mid-cash-up, not a developer, so it never shows that English sentence: a
 * reason becomes its sentence in the till's language, and anything else —
 * an `ApiError` with no reason, a thrown `Error` such as `toMinorUnits`
 * raises on unparsable input, a non-`Error` value — becomes the modal's own
 * generic fallback instead.
 */
export function shiftErrorMessage(caught: unknown, t: (key: MessageKey) => string): string {
  if (caught instanceof ApiError && caught.reason) return t(`error.${caught.reason}`);
  return t("pos.shift.failed");
}
